import type { UfsaKatalogErgebnis } from '../../services/geminiService';

/**
 * Was die Vorschlagsliste des Smart-Generators ueber ihre Herkunft sagt.
 *
 * Reine Funktion neben `UfsaEntryForm.tsx`, damit die Entscheidung ohne DOM
 * pruefbar ist: Kommt der Grundkatalog als Ersatz, weil die KI nicht
 * geantwortet hat, muss das sichtbar sein — sonst haelt jemand fuenf
 * allgemeine Beispiele fuer eine Auswertung seines Bauvorhabens. Deshalb ist
 * im Ersatzfall auch nichts vorausgewaehlt: „Ausgewaehlte uebernehmen" darf
 * nicht mit einem Klick die ganze Beispiel-Liste in den Katalog schieben.
 */
export interface VorschlagsAnzeige {
    /** Ueberschrift ueber der Liste. */
    titel: string;
    /** Sichtbarer Hinweis zur Herkunft; null, wenn die KI geantwortet hat. */
    hinweis: string | null;
    /** Was die KI meldete (Netz, Proxy, Kontingent); null ohne Ausfall. */
    fehlerDetail: string | null;
    /** Vorausgewaehlte Zeilen (Indizes in `eintraege`). */
    vorauswahl: number[];
}

export const ERSATZ_TITEL = 'Vorschläge aus dem Grundkatalog';
export const ERSATZ_HINWEIS =
    'KI nicht erreichbar – diese Einträge stammen aus dem Grundkatalog. Sie sind allgemeine Beispiele '
    + 'und keine Auswertung Ihrer Beschreibung. Nur übernehmen, was auf dieses Bauvorhaben zutrifft.';

export const vorschlagsAnzeige = (ergebnis: UfsaKatalogErgebnis): VorschlagsAnzeige => {
    if (ergebnis.quelle === 'ersatz') {
        return {
            titel: ERSATZ_TITEL,
            hinweis: ERSATZ_HINWEIS,
            fehlerDetail: ergebnis.fehler,
            vorauswahl: [],
        };
    }
    return {
        titel: 'Gefundene Vorschläge',
        hinweis: null,
        fehlerDetail: null,
        vorauswahl: ergebnis.eintraege.map((_, i) => i),
    };
};
